
import { connect } from "react-redux";

import CustomInputV2 from "../../../common/CustomInputV2";
import CustomSelect from '../../../common/CustomSelect';
import CustomSelectWeek from '../../../common/CustomSelectWeek';
import CustomSelectAndList from '../../../common/CustomSelectAndList';

function PromptProperties(props) {
    const { properties, setProperties } = props;

    const handleValueChange = (e, key, index) => {
        setProperties(
            properties?.map((prp, i) => {
                if (i == index) {
                    return {
                        ...prp,
                        value: e.target.value,
                    }
                }

                return prp;
            })
        );
    }


    const minPerWorkout = properties?.find(p => p?.key == "averageMinPerWorkout")?.value * 1;
    const programs = (minPerWorkout == 0 || isNaN(minPerWorkout)) ? props?.Program?.all?.list : props?.Program?.all?.list.filter(p => (p?.averaged_workout_video_time / 60) <= minPerWorkout);

    const allPrograms = programs?.map(program => {
        return {
            // label: `${program?.title}`,
            // label: `${program?.title} (program type: ${program?.type?.toUpperCase()}) (${program?.timeline} program w/ ${program?.count} workouts w/ an average of ${Math.round(program?.averaged_workout_video_time / 60)} minutes duration per workout)`,
            label: `${program?.title} (program type: ${program?.type?.toUpperCase()}, average workout length: ${program?.time} minutes per workout, Program ID: ${program?.id} )`,
            value: program?.id,
        }
    });


    return (
        <div id="opp-prompt-properties">
            {
                properties?.map((p, index) => {
                    return (
                        <div key={"opp-p-p-card-" + index} className="opp-pp-item">
                            <h6>{p?.name} <em> {`{{${p?.key}}}`} </em></h6>
                            <div>
                                {
                                    p?.type == "text" &&
                                    <CustomInputV2
                                        placeholder="Text Value"
                                        value={p?.value}
                                        type="text"
                                        onChange={(e) => {
                                            handleValueChange(e, p?.key, index)
                                        }}
                                        name="name"
                                    />
                                }

                                {
                                    p?.type == "date" &&
                                    <CustomInputV2
                                        placeholder="Date Value"
                                        value={p?.value}
                                        type="date"
                                        onChange={(e) => {
                                            handleValueChange(e, p?.key, index)
                                        }}
                                        name="name"
                                    />
                                }

                                {
                                    p?.type == "select" &&
                                    <CustomSelect
                                        name="select"
                                        options={[
                                            { label: "", value: "" },
                                            ...p?.options
                                        ]}
                                        value={p?.value}
                                        onChange={(e) => {
                                            handleValueChange(e, p?.key, index)
                                        }}
                                    />
                                }

                                {
                                    p?.type == "week" &&
                                    <CustomSelectWeek
                                        value={p?.value}
                                        onChange={(selected) => {
                                            handleValueChange({
                                                target: {
                                                    value: selected,
                                                }
                                            }, p?.key, index)
                                        }}
                                    />
                                }

                                {
                                    p?.type == "program" &&
                                    <CustomSelectAndList
                                        options={[
                                            { label: "", value: "" },
                                            ...allPrograms
                                        ]}
                                        value={p?.value}
                                        onChange={(selected) => {
                                            handleValueChange({
                                                target: {
                                                    value: selected,
                                                }
                                            }, p?.key, index)
                                        }}
                                    />
                                }

                            </div>
                        </div>
                    )
                })
            }
        </div>
    );
}

const mapStateToProps = (state) => ({
    Program: state.Program,
})

export default connect(mapStateToProps, {
})(PromptProperties);
